module.exports = __webpack_public_path__ + "assets/img/s3_chart-3.e9732358.png";